<template>
  <div class="table-box">
    <el-dialog :title="showTitle" :visible.sync="dialogVisible" top="0" width="65%" :before-close="handleClose"
      :close-on-click-modal="false">
      <el-row :gutter="10" class="dialogBtns">
        <el-button :type="display === 0 ? 'primary' : 'info'" @click="sendMsg">工单信息
        </el-button>
        <el-button :type="display === 1 ? 'primary' : 'info'" @click="disposeMsg">服务信息
        </el-button>
        <el-button v-show="btnActive" :type="display === 2 ? 'primary' : 'info'" @click="callbackMag">回访信息
        </el-button>
        <el-button :type="display === 3 ? 'primary' : 'info'" @click="orderLog">工单日志
        </el-button>
        <el-button :type="display === 4 ? 'primary' : 'info'" @click="seeEva">查看评价
        </el-button>
      </el-row>
      <CallbackVisitDialog ref="CallbackVisitDialog" @updateList="updateList" :showTitle="showTitle"
        :orderInfo="callbackForm" v-show="display === 0" @sucessSubmit="handleClose"></CallbackVisitDialog>
      <!-- 处理信息 -->
      <div v-show="display === 1">
        <div style="height: 12px; margin-top: 30px"></div>
        <el-form label-width="180px" ref="form" :model="callbackForm">
          <el-form-item label="APP用户反馈语音评价1：">
            <audio controls="controls" preload="auto" class="audioActive" :src="callbackForm.estimateRecord"
              disabled></audio>
          </el-form-item>

          <el-row>
            <el-col :span="12">
              <el-form-item label="开始时间：">
                <!-- <el-input v-model="callbackForm.timeStart" :disabled="showTitle !== '编辑'"></el-input> -->
                <el-date-picker :disabled="showTitle !== '编辑'" v-model="callbackForm.timeStart" type="datetime"
                  placeholder="请选择开始时间" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                  @change='timeChange' clearable></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="结束时间：">
                <!-- <el-input v-model="callbackForm.timeEnd" :disabled="showTitle !== '编辑'"></el-input> -->
                <el-date-picker :disabled="showTitle !== '编辑'" v-model="callbackForm.timeEnd" type="datetime"
                  @change='timeChange1' placeholder="请选择结束时间" format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss" clearable></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="showTitle == '查看' || showTitle == '撤回' || showTitle == '作废' || showTitle == '回访' || showTitle == '处理'">
            <el-col :span="12" >
              <el-form-item label="服务人员头像：">
                <div style="display: flex">
                  <div class="imgBox">
                    <el-image  :src="callbackForm.staffPhoto" class="img"
                      :preview-src-list="[callbackForm.staffPhoto]"></el-image>
                  </div>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="服务对象头像：">
                <div style="display: flex">
                  <div class="imgBox">
                    <el-image :src="callbackForm.customerPhoto" class="img"
                      :preview-src-list="[callbackForm.customerPhoto]"></el-image>
                  </div>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="服务内容：">
            <el-input disabled type="textarea" v-model="callbackForm.serviceText"></el-input>
          </el-form-item>

          <el-form-item label="服务开始结束图片：">
            <div style="display: flex">
              <div class="imgBox">
                <el-image v-if="callbackForm.picStart" :src="callbackForm.picStart" class="img"
                  :preview-src-list="[callbackForm.picStart]"></el-image>
              </div>
              <div class="imgBox">
                <el-image v-if="callbackForm.picFinished" :src="callbackForm.picFinished" class="img"
                  :preview-src-list="[callbackForm.picFinished]"></el-image>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="服务中图片：">
            <el-image v-for="(item, index) in picRunning" :key="index" :src="item" class="img"
              style="width: 150px; height: 150px; margin-right: 10px" :preview-src-list="picRunning"></el-image>
          </el-form-item>
          <el-form-item label="工作视频：">
            <div class="uploadBox">
              <div class="uploadFlex">
                <!-- {{gongdanForm.video}} -->
                <video id="myvideo1" :src="callbackForm.videoUrl" style="width: 200px" ref="videoId" autoplay="true"
                  controls muted></video>
              </div>
            </div>
          </el-form-item>
          <!-- <el-divider></el-divider>
<div style="height: 12px; margin-top: 30px; color: #169bd5">
  是否合格
</div>
<el-divider></el-divider>
<el-form-item label="状态：" prop="active">
  <el-radio-group
      v-model="callbackForm.failure"
      @change="disqualificationFun"
  >
    <el-radio label="合格"></el-radio>
    <el-radio label="不合格"></el-radio>
  </el-radio-group>
</el-form-item> -->
        </el-form>
      </div>
      <!-- 回访信息 -->
      <div v-show="display === 2">
        <div style="height: 12px; margin-top: 30px; color: #169bd5">
          回访信息
        </div>
        <el-divider></el-divider>
        <el-form label-width="180px" ref="form" :model="callbackForm" :disabled="showTitle !== '回访'">
          <el-form-item label="客户名称：">
            <el-col :span="10">
              <el-input v-model="callbackForm.customerName" disabled></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="联系方式：">
            <el-row :gutter="10">
              <el-col :span="10">
                <el-input v-model="callbackForm.customerphone" disabled></el-input>
              </el-col>
              <el-col :span="1">
                <i class="el-icon-phone" title="电话" style="cursor: pointer"
                  @click="callPhone(callbackForm.customerphone, '1')"></i>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="地址:">
            <div style="display: flex; margin-bottom: 5px">
              <el-input disabled placeholder="请输入" v-model="callbackForm.provinceName"></el-input>
              <el-input disabled placeholder="请输入" v-model="callbackForm.city"></el-input>
              <el-input disabled placeholder="请输入" v-model="callbackForm.areaName"></el-input>
              <el-input disabled placeholder="请输入" v-model="callbackForm.streetName"></el-input>
              <!-- @change="handleCommunityChange" -->
              <el-input disabled placeholder="请输入" v-model="callbackForm.communityName"></el-input>
            </div>
            <el-input v-model="callbackForm.address" style="padding: 0px; border: 0" disabled class="el-input__inner"
              placeholder="请输入关键字" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item style="margin-bottom: 0px">
            <audio controls="controls" style="margin-left: 0" preload="auto" class="audioActive"
              :src="callbackForm.recVisit"></audio>
          </el-form-item>
          <el-form-item label="图片：">
            <el-upload :action="actionUrl" :show-file-list="false" :on-success="(file, fileList) => {
                handleAvatarSuccess(file, fileList)
              }
              " :before-upload="beforeAvatarUpload" accept=".jpg,.png">
              <div class="avatar" v-if="callbackForm.pictureVisit">
                <img :src="callbackForm.pictureVisit" style="width: 178px; height: 178px" />
              </div>
              <div v-else>
                <i class="el-icon-plus avatar_uploader avatar-uploader-icon" style="border: 1px solid #ddd"></i>
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item label="是否通过App处理工单：" prop="fromApps">
            <el-radio-group v-model="callbackForm.fromApps" @change="timeTap">
              <el-radio label="0">是</el-radio>
              <el-radio label="1">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="上传图片是否符合规范：" prop="rightPic">
            <el-radio-group v-model="callbackForm.rightPic" @change="timeTap">
              <el-radio label="0">是</el-radio>
              <el-radio label="1">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="服务时间是否符合规范：" prop="rightTime">
            <el-radio-group v-model="callbackForm.rightTime" @change="timeTap">
              <el-radio label="0">是</el-radio>
              <el-radio label="1">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="拨打状态：" prop="dialStatus">
            <el-radio-group v-model="callbackForm.dialStatus">
              <el-radio label="0">正常接听</el-radio>
              <el-radio label="1">无人接听</el-radio>
              <el-radio label="2">关机</el-radio>
              <el-radio label="3">停机</el-radio>
              <el-radio label="4">空号</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否上传语音评价：" prop="rightEstimateRecord">
            <el-radio-group v-model="callbackForm.rightEstimateRecord" @change="timeTap">
              <el-radio label="0">是</el-radio>
              <el-radio label="1">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="服务对象评价：">
            <el-input type="textarea" v-model="callbackForm.estimate"></el-input>
          </el-form-item>
          <el-form-item label="服务企业（组织）评价：">
            <el-input type="textarea" v-model="callbackForm.jiamengEstimate"></el-input>
          </el-form-item>
          <el-form-item label="客户满意度：">
            <el-select v-model="callbackForm.estimateLevel" placeholder="请选择">
              <el-option value="0" label="未评价"></el-option>
              <el-option value="1" label="没有服务"></el-option>
              <el-option value="2" label="不满意"></el-option>
              <el-option value="3" label="服务一般"></el-option>
              <el-option value="4" label="基本满意"></el-option>
              <el-option value="5" label="非常满意"></el-option>
              <!-- <el-option
    v-for="item in estimateLevelList"
    :key="item.value"
    :label="item.label"
    :value="item.value"
>
</el-option> -->
            </el-select>
          </el-form-item>
          <el-form-item label="是否上门：">
            <el-radio-group v-model="callbackForm.visited">
              <el-radio label="0">是</el-radio>
              <el-radio label="1">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="回访结果：">
            <el-radio-group v-model="callbackForm.visitResults" @change="visitTap">
              <el-radio label="0">合格</el-radio>
              <el-radio label="1">不合格</el-radio>
              <el-radio label="2">作废</el-radio>
              <el-radio label="3">虚假工单</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="理由：">
            <el-input type="textarea" v-model="callbackForm.visitReason"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div v-if="display === 4 && isBusiness" class='business'>
        <div class='nameeva'>评价内容：{{ callbackForm.servicepgdEvaluation.otherContent }}</div>
        <div class="flex">
          <span>助老员评价</span>
          <el-rate disabled v-model="callbackForm.servicepgdEvaluation.serviceContentLevel"></el-rate>
        </div>
        <div class="flex">
          <span>服务质量程度</span>
          <el-rate disabled v-model="callbackForm.servicepgdEvaluation.serviceQualityLevel"></el-rate>
        </div>
        <div class="flex">
          <span>服务人员态度</span>
          <el-rate disabled v-model="callbackForm.servicepgdEvaluation.serviceAttitudeLevel"></el-rate>
        </div>
      </div>
      <!-- 工单列表 -->
      <logTable v-show="display === 3" :tableData='callbackForm.servicepgdProcessRecordList'></logTable>
      <el-divider v-if="showTitle !== '查看'"></el-divider>
      <div class="btn">
        <template v-if="['编辑', '回访'].includes(showTitle)">
          <el-button type="primary" @click="send">确定</el-button>
          <!-- <el-button type="success" @click="handleTip" v-show="display === 2"
            >指派
          </el-button> -->
        </template>
        <el-button v-if="showTitle === '处理'" type="primary" @click="chuLiSend">处理</el-button>
        <el-button v-if="showTitle === '撤回' || showTitle === '作废'" type="primary" @click="chehui">撤回</el-button>
        <el-button v-if="showTitle === '申请作废' || showTitle === '处理' || showTitle === '回访'" type="primary"
          @click="shenQingZuoFeiModal">申请作废</el-button>
        <el-button v-if="showTitle === '作废'" type="primary" @click="zuoFeiSubmit">作废</el-button>
        <el-button v-if="showTitle !== '查看'" @click="handleClose" type="info">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog title="指派" :visible.sync="handleVisible" width="30%" :before-close="toCancel"
      :close-on-click-modal="false">
      <el-form :model="serviceH" label-width="90px" :rules="rules" ref="serviceH">
        <el-form-item label="机构:" prop="servesStation">
          <el-select v-model="serviceH.servesStation" @change="getService" style="width: 100%">
            <el-option v-for="(item, index) in serviceStaData" :key="index" :value="item.id"
              :label="item.statName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="服务人员:" prop="servesName">
          <el-select v-model="serviceH.servesName" @change="changeName" style="width: 100%">
            <el-option v-for="(item, index) in serviceService" :key="index" :value="item.id"
              :label="item.personName"></el-option>
          </el-select>
        </el-form-item>
        <div style="
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 15px;
          ">
          <el-button @click="toSend('serviceH')" type="primary">确定
          </el-button>
          <el-button @click="toCancel('serviceH')" type="info">取消 </el-button>
        </div>
      </el-form>
    </el-dialog>

    <el-dialog title="申请作废" :visible.sync="zuoFeiVisible" width="30%" :before-close="handleClose"
      :close-on-click-modal="false">
      <div class="cancellationBox">
        <div style="width: 150px">申请作废的理由：</div>
        <el-input v-model="closeReason" type="textarea" :autosize="{ minRows: 4 }"></el-input>
      </div>
      <div style="
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 15px;
        ">
        <el-button type="primary" @click="cancelSend">确 定</el-button>
        <el-button @click="zuoFeiClose">取 消</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import request from "@/utils/request.js"
import QueryForm from "@/component/queryform.vue"
import VisitDialog from "../component/visitDialog.vue"
import CallbackVisitDialog from "../component/callbackVisitDialog"
import logTable from "../component/logTable"
import headLine from "../../components/headline"
import baseURL from "@/api/baseURL"
import exportVue from "@/utils/exportVue"
import audioLink from "@/api/audio"

export default {
  components: {
    VisitDialog,
    headLine,
    QueryForm,
    CallbackVisitDialog,
    logTable
  },
  props: {
    isBusiness: {
      type: Boolean,
      default: false,
    },
    showVisit: {
      type: Boolean,
      default: false,
    },
    showTitle: {
      type: String,
      default: "",
    },
    orderInfo: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      zuoFeiVisible: false,
      closeReason: "",
      dataId: 0,
      queryForm: {
        orderName: "",
        customerType: "",
        serveproductName: "",
        servestationName: "",
        servePersonName: "",
      },
      chooseRadio: [],
      tableData: [],
      serviceH: {
        servesStation: "",
        servesName: "",
      },
      serverinfoObj: {
        supplePic: [],
        suppleVideo: "",
        suppleRecord: "",
      },
      fileList: [],
      serviceStaData: [],
      serviceService: [],
      handleVisible: false,
      totalCount: 0,
      multipleSelection: [],
      actionUrl: baseURL + "/jjyl/controller/uploadController/info/uploadPhoto",
      query: {
        pageNo: 1,
        pageSize: 10,
      },
      dialogVisible: false,
      sendActive: true,
      btnActive: true,
      display: 0,
      callbackForm: {},
      estimateLevelList: [
        { value: "0", label: "未评价" },
        { value: "1", label: "没有服务" },
        { value: "2", label: "不满意" },
        { value: "3", label: "服务一般" },
        { value: "4", label: "基本满意" },
        { value: "5", label: "非常满意" },
      ],
      rules: {
        servesStation: [
          {
            required: true,
            message: "请选择机构",
            trigger: "change",
          },
        ],
        servesName: [
          {
            required: true,
            message: "请选择服务人员",
            trigger: "change",
          },
        ],
      },
      isCome0ptions: [
        {
          value: "1",
          label: "是",
        },
        {
          value: "0",
          label: "否",
        },
      ],
      isSearchContent: true,
      picRunning: [],
      routerLink: "",
    }
  },
  created() {
    this.callback(this.orderInfo.id)
    this.getStationList()
    this.routerLink = this.$route.path
  },
  methods: {
    updateList() {
      this.$emit("updateList")
      this.dialogVisible = false
    },
    // 回访
    visitTap(val) {
      // this.callbackForm.visitResults = val
      this.$forceUpdate()
    },
    Reset() {
      this.queryForm = {}
      this.getDataList()
    },
    shenQingZuoFeiModal() {
      this.zuoFeiVisible = true
    },
    // 关闭申请作废弹框
    zuoFeiClose() {
      this.zuoFeiVisible = false
      this.closeReason = ""
      this.$emit("input", false)
    },
    // 发送申请作废
    cancelSend() {
      if (!this.closeReason) {
        this.$message.error("请输入作废理由")
        return
      }
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })
      // 修改状态为待作废
      this.orderInfo.states = "4"
      // 添加作废理由
      this.orderInfo.closeReason = this.closeReason
      // 添加作废申请人
      this.orderInfo.askCloseName = this.$store.state.info.name
      this.orderInfo.states = 4
      request({
        url: "/jjyl/servicePgd/info/Invalid",
        method: "POST",
        data: this.orderInfo,
      })
        .then((res) => {
          this.handleClose()
          if (res.code === 200) {
            loading.close()
            this.$message.success("申请作废成功")
            this.$emit("updateList")
          } else {
            loading.close()
            this.$message.error("申请作废失败")
          }
          this.getDataList()
        })
        .catch((error) => {
          loading.close()
        })
    },
    zuoFeiSubmit() {
      this.$confirm("确定作废?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        request({
          url: "/jjyl/servicePgd/info/End",
          method: "POST",
          data: {
            id: this.orderInfo.id,
          },
        }).then((res) => {
          if (res.code === 200) {
            this.$message.success("作废成功")
            this.$emit("updateList")
            this.handleClose()
          } else {
            this.$message.error("作废失败")
          }
          this.getDataList()
        })
      })
    },
    chuLiSend() {
      request({
        url: "/jjyl/servicePgd/info/Handle",
        method: "POST",
        data: {
          id: this.orderInfo.id,
        },
      }).then((res) => {
        if (res.code === 200) {
          this.$emit("updateList")
          this.handleClose()
        }
      })
    },
    send() {
      if (this.showTitle === "派发") {
        this.$refs.CallbackVisitDialog.payOut()
      } else if (this.showTitle === "编辑") {
        this.$refs.CallbackVisitDialog.send()
        // this.$emit("updateList")
        // this.handleClose()
      } else {
        const serverObj = this.$refs.CallbackVisitDialog.serverObj
        const changeContent = this.$refs.CallbackVisitDialog.changeContent
        const self = this
        const data = Object.assign(serverObj, this.callbackForm)
        data.closeReason = self.callbackForm.visitReason
        if (Array.isArray(changeContent)) {
          data.changeContent = changeContent.join(",")
        }
        data.states = "3"
        let url = ""
        if (self.callbackForm.visitResults == 0) {
          url = "/jjyl/servicePgd/info/Visit"
        } else if (self.callbackForm.visitResults == 1) {
          if (self.callbackForm.visitReason == undefined) {
            self.$message.error("请输入不合格理由")
            return
          }
          url = "/jjyl/servicePgd/info/visitAbnormal"
          data.id = self.callbackForm.id
        } else {
          if (self.callbackForm.visitReason == undefined) {
            self.$message.error("请输入理由")
            return
          }
          url = "/jjyl/servicePgd/info/Invalid"
          data.states = self.callbackForm.visitResults == 2 ? "4" : "8"
          // 添加作废理由
          data.visitReason = self.callbackForm.visitReason
          data.orderNum = self.callbackForm.orderNum
          data.id = self.callbackForm.id
          // 添加作废申请人
          data.askCloseName = self.$store.state.info.name
        }
        request({
          url: "/jjyl/servicePgd/info/Visit",
          method: "POST",
          data: {
            ...data,
            id: this.dataId,
          },
        }).then((res) => {
          if (res.code === 200) {
            if (
              self.callbackForm.visitResults == 2 ||
              self.callbackForm.visitResults == 3
            ) {
              self.getCancle(url, data)
            } else if (self.callbackForm.visitResults == 1) {
              self.getNoPass(url, data)
            } else {
              this.$message.success(res.message)
              this.handleClose()
              this.getDataList()
            }
            this.$emit("updateList")
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },
    handleAvatarSuccess(res, file) {
      this.$set(this.callbackForm, "pictureVisit", res.content)
    },
    beforeAvatarUpload() { },
    // 作废 虚拟工单
    getCancle(url, parmar) {
      const self = this
      request({
        url: url,
        method: "POST",
        data: parmar,
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.message)
          this.handleClose()
          this.getDataList()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    //不合格
    getNoPass(url, parmar) {
      const self = this
      request({
        url: url,
        method: "POST",
        data: parmar,
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.message)
          this.handleClose()
          this.getDataList()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    //回访弹窗打开
    async callback(id) {
      this.dialogVisible = true
      console.log(id)
      this.dataId = id
      await this.getDetails(id)
    },
    // 回访弹框关闭
    handleClose() {
      this.display = 0
      this.dialogVisible = false
      this.$emit("input", false)
      this.$emit("handClose", false)
      this.callbackForm = {}
      if (this.$refs.CallbackVisitDialog) {
        this.$refs.CallbackVisitDialog.changeContent = []
      }
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.resetFields()
      })
    },
    mobandaochu() {
      this.request2({
        url: "/jjyl/servicePgd/info/Templatedownload",
        method: "POST",
        data: {
          pageNo: this.query.pageNum,
          pageSize: this.query.pageSize,
        },
        responseType: "blob",
      }).then((resp) => {
        if (resp) {
          const blob = new Blob([resp], {
            type: "application/vnd.ms-excel",
          })
          const fileName = "导入模板.xls"
          const linkNode = document.createElement("a")
          linkNode.download = fileName //a标签的download属性规定下载文件的名称
          linkNode.style.display = "none"
          linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
          document.body.appendChild(linkNode)
          linkNode.click() //模拟在按钮上的一次鼠标单击
          URL.revokeObjectURL(linkNode.href) // 释放URL 对象
          document.body.removeChild(linkNode)
          this.$message.success("导出成功")
        }
      })
    },
    createExcel() {
      this.request2({
        url: "/jjyl/servicePgd/info/export",
        method: "POST",
        excel: true,
        data: {
          customerphone: this.queryForm.customerphone,
          pageNo: this.query.pageNo,
          pageSize: this.query.pageSize,
          orderNum: this.queryForm.orderNum,
          states: "2",
          type: this.queryForm.customerType || "3",
          // customerType: this.queryForm.customerType,
          customerName: this.queryForm.customerName,
          timeStart: this.queryForm.timeStart,
          timeEnd: this.queryForm.timeEnd,
          position: this.queryForm.position,
          servestationName: this.queryForm.servestationName,
          serveproductName: this.queryForm.serveproductName,
          servePersonName: this.queryForm.servePersonName,
        },
        responseType: "blob",
      }).then((res) => {
        if (res) {
          const blob = new Blob([res], {
            type: "application/vnd.ms-excel",
          })
          const fileName = "残联工单.xls"
          const linkNode = document.createElement("a")
          linkNode.download = fileName //a标签的download属性规定下载文件的名称
          linkNode.style.display = "none"
          linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
          document.body.appendChild(linkNode)
          linkNode.click() //模拟在按钮上的一次鼠标单击
          URL.revokeObjectURL(linkNode.href) // 释放URL 对象
          document.body.removeChild(linkNode)
          this.$message.success("导出表格成功")
        }
      })
    },
    async fileChange(event) {
      const file = event.target.files[0]
      const personType = "1"
      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
      let formData = new FormData()
      formData.append("personType", personType)
      formData.append("file", file)
      let result = await this.$http.post(
        "/jjyl/servicePgd/info/ServicePgdExcel",
        formData,
        config
      )
      // 清空文件
      const fileEle = document.getElementById("speechUpload")
      fileEle.value = ""
      if (result.code === 200) {
        this.$message.success(result.message)
        this.getDataList()
      } else {
        this.$message.warning(result.message)
      }
    },
    statesFormat(row, column) {
      if (row.states === 0) {
        return "待派发"
      } else if (row.states === 1) {
        return "待处理"
      } else if (row.states === 2) {
        return "待回访"
      } else if (row.states === 3) {
        return "服务完成"
      } else if (row.states === 4) {
        return "待作废"
      } else if (row.states === 5) {
        return "已作废"
      } else if (row.states === 100) {
        return "移动终端接单"
      }
    },
    estimateLevelFormat(row, column) {
      if (row.estimateLevel === "1") {
        return "没有服务"
      } else if (row.estimateLevel === "2") {
        return "不满意"
      } else if (row.estimateLevel === "3") {
        return "服务一般"
      } else if (row.estimateLevel === "4") {
        return "基本满意"
      } else if (row.estimateLevel === "5") {
        return "非常满意"
      }
    },
    async detailsVisit(title, row) {
      if (title === "新增") {
        // this.showTitle = title
        this.showVisit = true
      } else {
        // this.showTitle = title
        await this.getDetails(row.id)
        this.showVisit = true
      }
    },
    getDataList() {
      let params = {
        customerphone: this.queryForm.customerphone,
        pageNo: this.query.pageNo,
        pageSize: this.query.pageSize,
        orderNum: this.queryForm.orderNum,
        states: "",
        type: this.queryForm.customerType || "3",
        customerUserType: this.queryForm.customerUserType,
        customerName: this.queryForm.customerName,
        timeStart: this.queryForm.timeStart,
        timeEnd: this.queryForm.timeEnd,
        position: this.queryForm.position,
        provinceId: this.queryForm.provinceId,
        cityId: this.queryForm.cityId,
        areaId: this.queryForm.areaId,
        streetId: this.queryForm.streetId,
        communityId: this.queryForm.communityId,
        servestationName: this.queryForm.servestationName,
        serveproductName: this.queryForm.serveproductName,
        servePersonName: this.queryForm.servePersonName,
        city: "",
        zone: "",
        street: "",
        shequ: "",
      }
      request({
        url: "/jjyl/servicePgd/info/findServicepgd",
        method: "POST",
        data: params,
      }).then((res) => {
        if (res.code === 200) {
          if (res.content) {
            this.tableData = res.content.list
            this.totalCount = res.content.count
          } else {
            this.tableData = []
            this.totalCount = 0
          }
        }
      })
    },
    getDetails(id) {
      request({
        url: "/jjyl/servicePgd/info/findServicepgdById",
        method: "POST",
        data: {
          id: id,
        },
      }).then((res) => {
        if (res.code === 200) {
          if (res.content) {
            this.callbackForm = res.content
            this.callbackForm.videoUrl = res.content.videoUrl
            this.callbackForm.recVisit =
              audioLink + "/" + this.callbackForm.recVisit

            if (res.content.picRunning) {
              this.picRunning = res.content.picRunning.split(",")
            }
          } else {
            this.callbackForm = {}
          }
        }
      })
    },
    //指派
    handleTip() {
      this.handleVisible = true
    },
    getStationList() {
      let params = {
        pageNO: 1,
        pageSize: 99,
      }
      request({
        url: "/jjyl/admin/serviceStation/info/findList",
        method: "POST",
        data: params,
      }).then((res) => {
        if (res.code === 200) {
          if (res.content) {
            this.serviceStaData = res.content.list || []
          } else {
            this.serviceStaData = []
          }
        }
      })
    },
    getService() {
      this.$set(this.serviceH, "servesName", "")
      this.serviceService = []
      this.getServiceData()
    },
    getServiceData() {
      let params = {
        pageNO: 1,
        pageSize: 99,
        serviceStationId: this.serviceH.servesStation,
      }
      request({
        url: "/jjyl/admin/serviceStaffCustomerCenter/info/findList",
        method: "POST",
        data: params,
      }).then((res) => {
        if (res.code === 200) {
          if (res.content) {
            this.serviceService = res.content.elderList.list || []
          } else {
            this.serviceService = []
          }
        }
      })
    },
    changeName(val) {
      this.serviceService.forEach((item) => {
        if (item.id == val) {
          this.serviceH.appointName = item.personName
        }
      })
    },
    toSend(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            appoint: this.serviceH.servesName,
            appointName: this.serviceH.appointName,
            servicePgdId: this.dataId,
          }
          request({
            url: "/jjyl/servicePgdReturnVisit/info/save ",
            method: "POST",
            data: params,
          }).then((res) => {
            if (res.code === 200) {
              this.handleVisible = false
              this.handleClose()
              this.getDataList()
            }
          })
        } else {
          return false
        }
      })
    },
    toCancel(formName) {
      this.handleVisible = false
      this.$refs[formName].resetFields()
    },
    QuerySearch() {
      this.getDataList()
    },
    //派发
    sendMsg() {
      this.display = 0
    },
    //处理
    disposeMsg() {
      this.display = 1
    },
    //回访
    callbackMag() {
      this.display = 2
      this.callbackForm.fromApps = "0"
      this.callbackForm.rightPic = "0"
      this.callbackForm.rightTime = "0"
      this.callbackForm.visited = "0"
      this.callbackForm.visitResults = "0"
      this.callbackForm.rightEstimateRecord = "0"
      this.chooseRadio = [1, 1, 1, 1]
    },
    //工单列表
    orderLog() {
      this.display = 3
    },
    seeEva() {
      this.display = 4
    },
    //补充资料
    InfoMag() {
      this.display = 4
      this.fileList = []
      request({
        url: "/jjyl/servicePgdSupple/info/get",
        method: "POST",
        data: {
          servicePgdId: this.dataId,
        },
      }).then((res) => {
        if (res.code === 200) {
          if (res.content == null || res.content == "null") {
            this.serverinfoObj = {}
          } else {
            this.serverinfoObj = res.content
            this.serverinfoObj.suppleRecord = res.content.suppleRecord
            this.serverinfoObj.suppleVideo = res.content.suppleVideo
            if (this.serverinfoObj.supplePic.length > 0) {
              this.serverinfoObj.supplePic =
                this.serverinfoObj.supplePic.split(",")
              this.fileList = this.serverinfoObj.supplePic.map((item) => {
                return {
                  url: item,
                }
              })
            }
          }
        }
      })
    },
    //回访中
    callbackingMag() {
      this.display = 3
    },
    // 切换评价 results
    timeTap(val) {
      if (val == 0) {
        this.chooseRadio.push(1)
      } else {
        this.chooseRadio.splice(0, 1)
      }
      console.log(
        this.chooseRadio.length,
        this.chooseRadio.length < 2,
        "选中情况"
      )
      if (this.chooseRadio.length < 2) {
        this.callbackForm.visitResults = "1"
      } else {
        this.callbackForm.visitResults = "0"
      }
      this.$forceUpdate()
    },
    // 点击撤回
    chehui() {
      this.$confirm("此操作将撤回该信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        request({
          url: "/jjyl/servicePgd/info/withdraw",
          method: "POST",
          data: {
            id: this.orderInfo.id,
          },
        }).then((res) => {
          if (res.code === 200) {
            this.$message.success("撤回成功")
            this.$emit("updateList")
            this.handleClose()
          } else {
            this.$message.error("撤回失败")
          }
          this.getDataList()
        })
      })
    },
    handleSelectionChange(rows) {
      this.multipleSelection = rows
    },
    returnAll() {
      var that = this
      var val = this.multipleSelection
      if (val.length > 0) {
        this.$confirm("确认批量回访吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            val.forEach(function (item, index) {
              request({
                url: "/jjyl/servicePgd/info/Visit",
                method: "POST",
                data: {
                  id: item.id,
                  visitResults: 0,
                  orderNum: item.orderNum,
                  states: 3,
                },
              })
            })
          })
          .then(() => {
            this.$message({
              type: "success",
              message: "批量回访成功!",
            })
            setTimeout(() => this.getDataList(), 500)
          })
      } else {
        this.$confirm("请选择要回访的项。", "提示")
      }
      this.$refs.multipleTable.clearSelection()
    },
    handleSizeChange(val) {
      this.query.pageSize = val
      this.getDataList()
    },
    handleCurrentChange(val) {
      this.query.pageNo = val
      this.getDataList()
    },
    timeChange(val) {
      this.$set(this.callbackForm, 'timeStart', val)
    },
    timeChange1(val) {
      console.log(val, 'val')
      this.$set(this.callbackForm, 'timeEnd', val)
    },
    //不合格事件
    disqualificationFun(data) {
      this.btnActive = data !== "不合格"
    },
    //打电话
    callPhone(phone, type) {
      if (phone == null || phone == "") {
        this.$message.warning("号码无效，暂无法拨号")
      } else {
        this.$store.dispatch("setPhone", phone)
        exportVue.$emit("question", true)
        setTimeout(() => {
          this.callType(phone, type)
        }, 5000)
      }
    },
    // 拨号处理
    callType(phone, type) {
      const self = this
      request({
        url: "/jjyl/traffic/callInfo/info/saveCallIdforNormalPdg",
        method: "POST",
        data: {
          remoteNum: phone,
          agentID: self.$store.state.seatNo,
          servicepgdId: self.dataId,
          callToType: type,
        },
      }).then((res) => { })
    },
  },
}
</script>

<style lang="less" scoped>
.table-operation {
  width: 100%;
  display: flex;
  cursor: pointer;
  justify-content: center;

  div {
    flex: 1;
  }
}

.dialogBtns {
  display: flex;
  justify-content: center;

  .el-button {
    margin-right: 40px;
  }
}

.btn {
  width: 100%;
  display: flex;
  justify-content: center;
}

.imgBox {
  margin-right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .img {
    margin-bottom: 10px;
    width: 150px;
    height: 150px;
  }

  .photoName {
    width: 70%;
    background-color: #169bd5;
    color: #ffffff;
    text-align: center;
    border-radius: 5px;
  }
}

.elder_manage_title {
  position: relative;
  width: 100%;
  margin-bottom: 15px;

  &::after {
    position: absolute;
    left: 120px;
    right: 0;
    display: block;
    content: "";
    border-bottom: 1px solid #e4e7ed;
  }

  .title {
    box-sizing: border-box;
    display: inline-block;
    width: 120px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #409eff;
    font-size: 14px;
    border: 1px solid #e4e7ed;
    border-bottom: none;
    border-radius: 4px 4px 0 0;
    box-sizing: border-box;
    background: #ffffff;
  }
}

.searchDomw {
  cursor: pointer;
}

.hui {
  color: #999;
}

.blue {
  color: #409eff;
}

.business {
  .nameeva {
    font-size: 16px;
    margin-bottom: 15px;
  }

  .flex {
    font-size: 16px;
    display: flex;
    justify-content: space-between;
    width: 300px;
    margin-bottom: 15px;

  }
}
</style>
